import type { DerivedGuide, DerivedLevel, DerivedStep } from './deriveGuide';

export const isGuideHidden = (guide?: DerivedGuide): boolean => !guide || guide.levels.length === 0 || guide.hidden;

// The widget shows ONE guide: the first level that is incomplete AND available
// (not locked). Locked levels are skipped; returns -1 when none qualifies.
export const currentGuideIndex = (guide: DerivedGuide): number =>
  guide.levels.findIndex((l) => !l.locked && l.progressPercentage < 100);

export const levelProgressLabel = (level: DerivedLevel): string => `${level.completedSteps} de ${level.totalSteps}`;

export type GuideRow = {
  step: DerivedStep;
  index: number;
  groupTitle?: string;
  isLast: boolean;
};

export const flattenLevelRows = (level: DerivedLevel): GuideRow[] => {
  const rows: GuideRow[] = [];
  let index = 0;
  level.groups.forEach((group) => {
    group.steps.forEach((step, stepIdx) => {
      index += 1;
      rows.push({
        step,
        index,
        groupTitle: stepIdx === 0 ? group.title : undefined,
        isLast: false,
      });
    });
  });
  if (rows.length > 0) rows[rows.length - 1].isLast = true;
  return rows;
};
